<template>
    <el-menu
        class="el-menu-vertical-demo el-menu-vertical"
        background-color="#002033"
        text-color="#fff"
        active-text-color="#ffd04b"
        :collapse="isCollapse"
        :unique-opened="true"
        :default-openeds="openeds"
        router
        :default-active="$route.path"
    >
        <div class="logo">
            <img v-show="!isCollapse" src="../../../assets/image/logo4.png" alt="" style="background-color: white;height: 60px;width: 100%;object-fit: cover;border: none;">
            <img v-show="isCollapse" src="../../../assets/image/logo5.png" alt="" style="background-color: white;height: 60px;width: 100%;object-fit: cover;border: none;">
        </div>
        <el-submenu index="1" v-for="(item,index) in menuList" :key="index">
            <template slot="title"><i class="el-icon-message"></i>{{ item.menuName }}</template>
            <template v-for="subItem in item.children[0].children">
                <el-menu-item-group :key="subItem.id">
                    <el-menu-item :index="'/'+ subItem.menuUrl" :key="subItem.id">
                        <i class="el-icon-menu"></i>
                        {{ subItem.menuName }}
                    </el-menu-item>
                </el-menu-item-group>
            </template>
        </el-submenu>
    </el-menu>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from "@/api/event-bus";
import { getAuthMenus } from "@/api/menuMange";

export default {
    name: "Aside",
    data() {
        return {
            openeds: ['1'],
            menuList: []
        }
    },
    computed: {
        ...mapState({
            isCollapse: state => state.isCollapse
        }),
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        EventBus.$on("logo", (msg) => {
            this.logo = msg
        });
        this.getAUthMenuList()
    },
    methods: {
        async getAUthMenuList(){
            const res = await getAuthMenus();
            if(res.code === '200'){
                if(res.data.menuDTOList.length === 0) {
                    await this.$router.replace('/selectPage')
                }

                this.menuList = res.data.menuDTOList
                this.$store.commit('menuList', res.data.permissionsList)
            }
        },
    }
}
</script>

<style scoped>
.el-menu{
    border-right-width: 0;
}
::v-deep .el-menu-item-group__title{
    padding: 0;
}
/*隐藏文字*/
::v-deep .el-menu--collapse  .el-submenu__title span{
    display: none;
}

::v-deep.el-menu:not(.el-menu--collapse) {
    width: 200px;
}
</style>
